// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kk-form-bottomtip[data-v-59023bc2]{color:gray;font-size:12px;line-height:1.5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
